import app from "../_app";

const nav = document.querySelector('.js-nav');
const header = document.querySelector('.js-header');
const explore = document.querySelector('.js-nav-explore');

if(nav) {
    if(app.viewport.isSmallerThan('lg')) {
        const navItems = [...nav.querySelectorAll('.js-nav-item')];
        const backTriggers = [...nav.querySelectorAll('.js-nav-back')];
        const navTriggers = [...document.querySelectorAll('.js-nav-trigger')];

        const navItemClickHandler = (e) => {
            e.preventDefault();

            if(e.currentTarget.parentElement.classList.contains('nav__subitem')) {
                e.currentTarget.nextElementSibling.firstElementChild.classList.add('nav__subsub--open');
                document.querySelector('.js-nav-items').classList.add('nav__items--subsub');
            }else{
                e.currentTarget.nextElementSibling.setAttribute('data-open', '');
                e.currentTarget.nextElementSibling.classList.add('nav__sub--open');
                e.currentTarget.parentElement.parentElement.classList.add('nav__items--sub');
            }
        };

        const backClickHandler = (e) => {
            if(e.currentTarget.closest('ul').classList.contains('nav__subsub')) {
                e.currentTarget.closest('ul').removeAttribute('data-open');
                document.querySelector('.js-nav-items').classList.remove('nav__items--subsub');

                [...document.querySelectorAll('.js-nav-sub-nav')].map(nav => {
                    nav.querySelector('ul').classList.remove('nav__subsub--open');
                });

            }else {
                e.currentTarget.closest('ul').removeAttribute('data-open');
                e.currentTarget.closest('ul').classList.remove('nav__sub--open');
                document.querySelector('.js-nav-items').classList.remove('nav__items--sub');


            }
        };

        const triggerClickHandler = () => {
            if(nav.hasAttribute('data-open')) {
                const openSubNavs = [...nav.querySelectorAll('.js-nav-sub-nav[data-open]')];
                header.classList.remove('header--nav-open');
                nav.removeAttribute('data-open');

                openSubNavs.map(openSubNav => openSubNav.removeAttribute('data-open'));

                app.unlockBody();
            } else {
                app.lockBody();
                nav.setAttribute('data-open', '');
                header.classList.add('header--nav-open');
            }
        };

        navItems.map(navItem => navItem.firstElementChild.addEventListener('click', navItemClickHandler));
        backTriggers.map(backTrigger => backTrigger.addEventListener('click', backClickHandler));
        navTriggers.map(navTrigger => navTrigger.addEventListener('click', triggerClickHandler));
    }
    if(app.viewport.isEqualOrGreaterThan('lg')) {
        const navItems = [...nav.querySelectorAll('.js-nav-item')];

        const navItemHoverHandler = (e) => {
            header.classList.add('header--nav-open');
        }
        const navItemOutHandler = (e) => {
            header.classList.remove('header--nav-open');
        }
        navItems.map(navItem => navItem.addEventListener('mouseover', navItemHoverHandler));
        navItems.map(navItem => navItem.addEventListener('mouseout', navItemOutHandler));
    }

    nav.removeAttribute('data-loading');
}

if(explore) {
    const items = [...explore.querySelectorAll('.js-nav-explore-item')];
    const pointers = [...nav.querySelectorAll('.js-nav-explore-pointer')];


    pointers.map((pointer) => {
        pointer.addEventListener('mouseover', () => {

            const elementDataValue = pointer.getAttribute('data-title');

            items.forEach(item => {
                const itemDataValue = item.getAttribute('data-title');
                if (elementDataValue === itemDataValue) {

                    item.classList.add('active');
                }
                else {
                    item.classList.remove('active');
                }
            });
        });
    })


}
